export const MOB_CABS_LANDING_AIRPORTCABS_CLICK =
  'Mob_Cabs_Landing_AirportCabs_Click';
export const MOB_CABS_LANDING_OUTSTATIONCABS_CLICK =
  'Mob_Cabs_Landing_OutstationCabs_Click';
export const MOB_CABS_LANDING_HOURLYRENTALS_CLICK =
  'Mob_Cabs_Landing_HourlyRentals_Click';
export const MOB_CAB_ONE_WAY_CLICK = 'Mob_Cab_One_Way_Click';
export const MOB_CAB_ROUND_TRIP_CLICK = 'Mob_Cab_Round_Trip_Click';
export const MOB_CABS_AT_LANDING_TO_AIRPORT_RADIO_BUTTON =
  'Mob_Cabs_AT_Landing_To_Airport_Radio_Button';
export const MOB_CABS_FROM_LANDING_TO_AIRPORT_RADIO_BUTTON =
  'Mob_Cabs_AT_Landing_From_Airport_Radio_Button';
export const MOB_CABS_LANDING_SWAP_SEARCH_PARAMS =
  'Mob_Cabs_Landing_Swap_Search_Params';
export const MOB_CABS_OW_LANDING_PICKUP_CLICK =
  'Mob_Cabs_OW_Landing_Pickup_Click';
export const MOB_CABS_OW_LANDING_DESTINATION_CLICK =
  'Mob_Cabs_OW_Landing_Destination_Click';
export const MOB_CABS_HR_LANDING_PICKUP_CLICK =
  'Mob_Cabs_HR_Landing_Pickup_Click';
export const MOB_CABS_AT_LANDING_CITY_CLICK = 'Mob_Cabs_AT_Landing_City_Click';
export const MOB_CABS_AT_LANDING_AIRPORT_CLICK =
  'Mob_Cabs_AT_Landing_Airport_Click';
export const MOB_CABS_LANDING_HR_PACKAGE_TYPE_CLICK =
  'Mob_Cabs_Landing_HR_Package_Type_Click';
export const MOB_CABS_OW_CALENDAR_PICKUP_TIME_CLICK =
  'Mob_Cabs_OW_Calendar_Pickup_Time_Click';
export const MOB_CABS_OW_CALENDAR_DROP_TIME_CLICK =
  'Mob_Cabs_OW_Calendar_Drop_Time_Click';
export const MOB_CABS_AT_CALENDAR_PICKUP_TIME_CLICK =
  'Mob_Cabs_AT_Calendar_Pickup_Time_Click';
export const MOB_CABS_HR_CALENDAR_PICKUP_TIME_CLICK =
  'Mob_Cabs_HR_Calendar_Pickup_Time_Click';
export const MOB_CABS_OW_LANDING_SEARCH_CLICK =
  'Mob_Cabs_OW_Landing_Search_Click';
export const MOB_CABS_RT_LANDING_SEARCH_CLICK =
  'Mob_Cabs_RT_Landing_Search_Click';
export const MOB_CABS_AT_LANDING_SEARCH_CLICK =
  'Mob_Cabs_AT_Landing_Search_Click';
export const MOB_CABS_HR_LANDING_SEARCH_CLICK =
  'Mob_Cabs_HR_Landing_Search_Click';
export const MOB_CABS_HR_LANDING_PICKUP_SELECT =
  'Mob_Cabs_HR_Landing_Pickup_Select';
export const MOB_CABS_OW_LANDING_PICKUP_SELECT =
  'Mob_Cabs_OW_Landing_Pickup_Select';
export const MOB_CABS_OW_LANDING_DESTINATION_SELECT =
  'Mob_Cabs_OW_Landing_Destination_Select';
export const MOB_CABS_RT_LANDING_PICKUP_SELECT =
  'Mob_Cabs_RT_Landing_Pickup_Select';
export const MOB_CABS_RT_LANDING_DESTINATION_SELECT =
  'Mob_Cabs_RT_Landing_Destination_Select';
export const MOB_CABS_AT_LANDING_PICKUP_SELECT =
  'Mob_Cabs_AT_Landing_Pickup_Select';
export const MOB_CABS_AT_LANDING_DESTINATION_SELECT =
  'Mob_Cabs_AT_Landing_Destination_Select';
export const MOB_CABS_LANDING_OW_ADD_STOPS_CLICK =
  'Mob_Cabs_Landing_OW_Add_Stops_Click';
export const MOB_CABS_LANDING_RT_ADD_STOPS_CLICK =
  'Mob_Cabs_Landing_RT_Add_Stops_Click';
export const MOB_CABS_LANDING_OW_CLOSE_STOP_CLICK =
  'Mob_Cabs_Landing_OW_Close_Stop_Click';
export const MOB_CABS_LANDING_RT_CLOSE_STOP_CLICK =
  'Mob_Cabs_Landing_RT_Close_Stop_Click';
